import { render, staticRenderFns } from "./manageDependency.vue?vue&type=template&id=4aa31f20"
import script from "./manageDependency.vue?vue&type=script&lang=ts"
export * from "./manageDependency.vue?vue&type=script&lang=ts"
import style0 from "./manageDependency.vue?vue&type=style&index=0&id=4aa31f20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports